import React, { useEffect, useRef, useState } from 'react'
import { toast } from 'react-toastify'
import Breadcrumb from '../../../components/common/breadcrumb'
import { getTaseron } from '../../../services/getTaseron'
import { getAllGroupages, getGroupageDetails } from './api'
import GrupajFilterArea from './components/GrupajFilterArea'
import GrupajList from './components/GrupajList'
import IslemlerPopup from './components/IslemlerPopup'
import PeronGuncelle from './components/PeronGuncelle'
import { useAuth } from '../../../auth'
const GrupajIslemleriV2 = () => {
    const [dataSource, setDataSource] = useState([])
    const [groupageDetails, setGroupageDetails] = useState({})
    const [taseronData, setTaseronData] = useState([]);
    const [contractData, setContratData] = useState([]);

    const { hasRole } = useAuth(13);

    const groupageRef = useRef()

    useEffect(() => {
        (async () => {

            try {

                const taseronlar = await getTaseron();
                setTaseronData(taseronlar.filter(item => item.transport_company === true));
                setContratData(taseronlar.filter(item => item.contract_owner == true));
            } catch (error) {
                console.error(error)
            }
        })();
    }, []);

    const refreshGroupageDetails = async (groupageNo) => {
        try {
            const details = await getGroupageDetails(groupageNo);
            setGroupageDetails(details);
            return { success: true };
        } catch (error) {
            let message = error?.response?.data?.error || error?.message || "Grupaj detayları alınırken hata oluştu"
            console.error('Error refreshing groupage details:', error);
            if (message.includes("no rows in result set")) {
                onFilter()
                setIsOpen(prev => ({ ...prev, islemler: false }))
                toast.info("Grupajda başka şase kalmamıştır. İşlemler ekranı kapatılıyor.")
                return { success: false, isEmpty: true };
            }
            else {
                toast.error(message);
                return { success: false, isEmpty: false };
            }
        }
    };

    const [isOpen, setIsOpen] = useState({
        islemler: false,
        peronGuncelle: false,
    })


    const onFilter = async (filter) => {
        document.getElementById('export-excel-button').style.visibility = "hidden"
        document.getElementById('print-all-button').disabled = true
        document.getElementById('islemler-button').disabled = true
        document.getElementById('peron-button').disabled = true
        document.getElementById('pdi-emri-listesi-button').disabled = true
        document.getElementById('rihtim-istenecek-button').disabled = true


        if (groupageRef.current) {
            groupageRef.current.instance.beginCustomLoading("Yükleniyor...")

        }
        try {
            const response = await getAllGroupages(filter)
            setDataSource(response.data)
            if (response.data === null) {
                toast.warn("Veri Bulunamadı", {
                    position: "top-center",
                    autoClose: 3000
                })
            }
        } catch (error) {
            console.error(error)
            toast.error("Grupajlar alınamadı", {
                position: "top-center",
                autoClose: 3000
            })
        } finally {
            if (groupageRef.current) {
                groupageRef.current.instance.endCustomLoading()
                document.getElementById('export-excel-button').style.visibility = "visible"
                document.getElementById('print-all-button').disabled = false
                document.getElementById('islemler-button').disabled = false
                document.getElementById('peron-button').disabled = false
                document.getElementById('pdi-emri-listesi-button').disabled = false
                document.getElementById('rihtim-istenecek-button').disabled = false
            }
        }
    }

    return (
        <>
            <Breadcrumb current="Grupaj İşlemleri" />
            <div className='p-1'>
                <GrupajFilterArea
                    onFilter={onFilter}
                    setDataSource={setDataSource}
                    setIsOpen={setIsOpen}
                    groupageRef={groupageRef}
                    setGroupageDetails={setGroupageDetails}
                />
                <GrupajList
                    dataSource={dataSource}
                    groupageRef={groupageRef}
                />
                <IslemlerPopup isOpen={isOpen}
                    groupageDetails={groupageDetails}
                    setIsOpen={setIsOpen}
                    taseronData={taseronData}
                    contractData={contractData}
                    detail={() => refreshGroupageDetails(groupageDetails.groupage_no)}
                    onFilter={onFilter}
                    groupageRef={groupageRef}
                    saseEklemeRole={hasRole("grupajislemleri_sase_add")}
                    saseCikarmaRole={hasRole("grupajislemleri_sase_delete")}
                />
                <PeronGuncelle isOpen={isOpen}
                    setIsOpen={setIsOpen}
                    groupageDetails={groupageDetails}
                    setGroupageDetails={setGroupageDetails}
                    detail={() => refreshGroupageDetails(groupageDetails.groupage_no)}
                    onFilter={onFilter}
                />

            </div>
        </>
    )
}

export default GrupajIslemleriV2